
<template>
    <div class="layout-contaner">
     <Layout>
        <Header>
            <h2 class="header-title"><img src="../assets/logo-text.png" alt=""> <span>项目外包服务平台 V1.0.0.203</span><p @click="loginOut">退出登录</p></h2>
            
        </Header>
        <Layout>
            <Sider class="menu" hide-trigger>
                <FatherNav></FatherNav>
            </Sider>
            <Content>  <router-view></router-view></Content>
        </Layout>
    </Layout>
    </div>
</template>
<script>
import FatherNav from "@/components/FatherNav.vue";
export default {
    components:{
        FatherNav
    },
    data(){
        return{

        }
    },
    mounted(){
         this.getInfo();
    },
    methods:{
        getInfo(){
            this.$post('api/manage.PersonCenter/getMemberInfo').then(res=>{
                if(res.code==1){
                    this.$setLS('AdminInfo',JSON.stringify(res.data))
                }
            })
        },
        loginOut(){
            this.$post('api/Login/logout').then(res=>{
                if(res.code==1){
                    this.$delLS('token');
                    this.$delLS('AdminInfo');
                     this.$router.push({ path: "/"});
                }
            })
        }
    }
}
</script>
<style lang="less">
html,body{
    height: 100%;
}
.menu{
    height: 100%;
}
.layout-contaner{
    height: 100%;
    >.ivu-layout{
        height: 100%;
        .ivu-layout-has-sider{
    height:  calc(~"100% - 64px");
}
    }
}
  .contaner-title{
        font-size: 18px;
        margin-bottom: 10px;
        >span:nth-of-type(1){
            color: #00AAE3;

        }
    }
.header-title{
    width: 100%;
    background-color:#01AAE3;
    color: #fff;
    height: 64px;
    line-height: 64px;
    padding-left: 40px;
    box-sizing: border-box;
    border-bottom: 5px solid #0197CA;
    // display: flex;
    img{
        height: 30px;
        margin-top: 15px;
        float: left;
    }
    span{
        font-size: 14px;
        margin-left: 20px;
        font-weight: normal;
        float: left;
    }
    p{
        float: right;
        margin-right: 50px;
        font-size: 15px;
        cursor: pointer;
        
    }
}

</style>


// WEBPACK FOOTER //
// src/view/comment.vue